import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { sliderPromotions } from "../data/PromotionData";

const MainSlider = () => {
	const defaultSlides = [
		{
			id: 21,
			image:
				"/images/promotions/main-banners/JILI_QUEST_UNLOCK_AND_WIN_XL.webp",
			className: "slider-banners",
			altxt: "Jili Quest Promotion",
			href: "/promotion/jili-quest",
		},
		// {
		//   id: 9,
		//   image: "/images/banners/FGH_CHRISTMAS_BANNER.webp",
		//   className: "slider-banners",
		//   altxt: "Christmas Banner FGH",
		//   href: "/",
		// },
		{
			id: 0,
			image: "/images/banners/WELCOME-BANNER-NEW-FGH-XL.webp?v=1",
			className: "slider-banners",
			altxt: "Welcome Banner FGH",
			href: "/",
		},
		// {
		//   id: 18,
		//   image:
		//     "/images/promotions/main-banners/VPLUS_ROAD_TO_GLORY_CHAMP_RUSH-XL.webp",
		//   className: "slider-banners",
		//   altxt: "VPlus Road To Glory",
		//   href: "/promotion/world-cup-champ-rush",
		// },
		{
			id: 12,
			image: "/images/banners/YOUR_MONEY_YOUR_CHOICE_XL.webp",
			className: "slider-banners",
			altxt: "Your Money Your Choice",
			href: "/profile#wallet",
		},

		// {
		//   id: 8,
		//   image: "/images/banners/POPOK-BANNER_XL.webp",
		//   className: "slider-banners",
		//   altxt: "Popok Casino Banner",
		//   href: "/live-casino",
		// },
		{
			id: 20,
			image:
				"/images/banners/UltimateGoldenDragonInferno_Banner_1903x550_HOT.webp",
			className: "slider-banners",
			altxt: "Ultimate Golden Dragon Inferno",
			href: "/slots/?provider=BETSOFT",
		},
		{
			id: 11,
			image: "/images/banners/HACKSAW-GAMING-NEW.webp",
			className: "slider-banners",
			altxt: "New Hacksaw Gaming Games at FGH",
			href: "/slots/?provider=HACKSAW",
		},
		{
			id: 17,
			image: "/images/banners/VPLUS.webp",
			className: "slider-banners",
			altxt: "New VPlus at FGH",
			href: "/slots/?provider=VPLUS",
		},
		{
			id: 16,
			image: "/images/banners/VERTEX-PLAY.webp",
			className: "slider-banners",
			altxt: "New Vertex Play at FGH",
			href: "/slots/?provider=VP",
		},
		{
			id: 15,
			image: "/images/banners/THE_JEALOUS_EX_XL.webp",
			className: "slider-banners",
			altxt: "The Jealous Ex",
			href: "/",
		},
		{
			id: 14,
			image: "/images/banners/FASTSPIN.webp",
			className: "slider-banners",
			altxt: "New FastSpin Games at FGH",
			href: "/slots/?provider=FASTSPIN",
		},

		{
			id: 13,
			image: "/images/banners/SIMPLEPLAY-NEW.webp",
			className: "slider-banners",
			altxt: "New Simpleplay Games at FGH",
			href: "/slots/?provider=YELLOWBAT",
		},

		// {
		//   id: 10,
		//   image: "/images/banners/YELLOWBAT-NEW.webp",
		//   className: "slider-banners",
		//   altxt: "New Yellowbat Games at FGH",
		//   href: "/slots/?provider=YELLOWBAT",
		// },

		// {
		//   id: 7,
		//   image: "/images/banners/JOLLIPLAY-BIG-WINS_XL.webp",
		//   className: "slider-banners",
		//   altxt: "Big Winners Jolliplay",
		//   href: "/",
		// },
		// {
		//   id: 1,
		//   image: "/images/banners/HABANERO_AT_FGH.webp",
		//   className: "slider-banners",
		//   altxt: "New Habanero Games at FGH",
		//   href: "/slots/?provider=HABANERO",
		// },
		// {
		//   id: 2,
		//   image: "/images/banners/WAZDAN_AT_FGH.webp",
		//   className: "slider-banners",
		//   altxt: "New Wazdan Games at FGH",
		//   href: "/slots/?provider=WAZDAN",
		// },
		// {
		//   id: 3,
		//   image: "/images/banners/BIGPOT_AT_FGH.webp",
		//   className: "slider-banners",
		//   altxt: "New Bigpot Games at FGH",
		//   href: "/slots/?provider=BIGPOT",
		// },
		// {
		//   id: 4,
		//   image: "/images/banners/ELBET_AT_FGH.webp",
		//   className: "slider-banners",
		//   altxt: "New ELBET Games at FGH",
		//   href: "/slots/?provider=ELBET",
		// },
		// {
		//   id: 5,
		//   image: "/images/banners/afb.webp",
		//   className: "slider-banners",
		//   altxt: "New AFB Games at FGH",
		//   href: "/slots/?provider=AFB",
		// },
		// {
		//   id: 6,
		//   image: "/images/banners/PLAYTECH_AT_FGH.webp",
		//   className: "slider-banners",
		//   altxt: "New Playtech Games at FGH",
		//   href: "/slots/?provider=PLAYTECH",
		// },
	];

	const dynamicSlides = sliderPromotions.map((promo, index) => ({
		id: index + 1,
		image: promo.bannerSrc,
		className: "slider-banners",
		altxt: promo.title,
		href: promo.tncLink,
	}));

	const slides = [...defaultSlides, ...dynamicSlides];

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: true,
		fade: true,
	};

	return (
		<div className="slider-container">
			<Slider {...settings}>
				{slides.map((slide) => (
					<div key={slide.id} className={slide.className}>
						<a href={slide.href}>
							<img src={slide.image} alt={slide.altxt} />
						</a>
					</div>
				))}
			</Slider>
		</div>
	);
};

export default MainSlider;
